import React from 'react'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import i18n from '~/i18n'
import ContactsMainNav from '../includes/contacts/contactsMainNav';


export default class SubscribersTemplateFP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupName: "",
            groupID: 0
        };

    }

    componentDidMount() {
        var groupID = this.props.groupID;
        this.setState({ groupID: groupID }, this.lookupGroup);
    }



    render() {


        return <Paper>
            <div className="page-header mar-b25">{i18n.t('nav:subscribers')}</div>
            <ContactsMainNav history={this.props.history} />
            {this.props.children}
        </Paper >

    }
}